import React from "react"
import styled from "styled-components"
import SliceZone from "../../../../utils/SliceZone"
import { Container, Title, Paragraph, Image } from "./Body.styles"
import { PrismicRichText } from "@prismicio/react"
import { BodyImageContainer } from "./Body.styles"

export const Body = ({ data }) => {
	const title = data.primary.title1[0]?.text
	const paragraphs = data.primary.rich_text[0]?.text
	const image = data.primary.image?.url
	const alignment = data.primary.titled_align
	var align = "left"
	if (alignment) {
		align = "center"
	}

	return (
		<Container>
			{title && <Title style={{ textAlign: "" + align + "" }}>{title}</Title>}
			<Paragraph>{<PrismicRichText field={data.primary.rich_text} />}</Paragraph>
			{image && (
				<BodyImageContainer>
					<Image src={image} />
				</BodyImageContainer>
			)}
		</Container>
	)
}
